import React, { useContext } from 'react';
import { inboxMobileView, status } from 'venuescanner-js/constants/thread';
import { ViewContext } from 'venuescanner-js/react/components/Inbox/context/ViewContext';
import { isOrganiser } from 'venuescanner-js/constants/user_type';
import CloseEnquiry from 'venuescanner-js/react/components/Inbox/components/Enquiry/EnquiryDetails/CloseEnquiry';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

function EnquiryMenuContainer({ thread, state, send }) {
  return isOrganiser(thread) ? (
    <OrganiserMenu thread={thread} state={state} send={send} />
  ) : (
    <HostMenu thread={thread} state={state} send={send} />
  );
}

const HostMenu = ({ thread, state, send }) => {
  const { activeMobileView, setActiveMobileView } = useContext(ViewContext);

  const toEnquiryView =
    (fn = () => {}) =>
    () => {
      setActiveMobileView(inboxMobileView.ENQUIRY);
      fn();
    };

  const { can } = thread;

  if (!can) return null;

  const markAsBookedClickHandler = toEnquiryView(() =>
    send({ type: 'MARK_AS_BOOKED' }),
  );
  const declineClickHandler = toEnquiryView(() => send({ type: 'CANCEL' }));
  const editQuoteHandler = toEnquiryView(() => send({ type: 'EDIT_QUOTE' }));

  const bottomClickHandler = () => {
    setActiveMobileView(inboxMobileView.CHAT);
  };

  return (
    <Stack
      p={2}
      className='enquiry-menu'
      direction='row'
      alignItems='center'
      justifyContent='start'
      spacing={2}>
      {(state.matches('open') || state.matches('quoteRequested')) && (
        <>
          <ButtonCTA color='primary' variant='contained' onClick={editQuoteHandler}>
            Send Quote
          </ButtonCTA>
          <HostMarkAsBookedButton onClick={markAsBookedClickHandler} />
          <DeclineEventButton onClick={declineClickHandler} />
        </>
      )}

      {state.matches('quoteReceived') && (
        <>
          <ButtonCTA
            color='primary'
            variant='contained'
            onClick={editQuoteHandler}>
            Edit Quote
          </ButtonCTA>
          <HostMarkAsBookedButton onClick={markAsBookedClickHandler} />
          <DeclineEventButton onClick={declineClickHandler} />
        </>
      )}

      {state.matches('booked') && thread.status === status.BOOKED_BY_HOST && (
        <UnmarkAsBookedButton
          onClick={toEnquiryView(() => send({ type: 'UNMARK_AS_BOOKED' }))}
        />
      )}

      {state.matches('booked') && thread.status === status.BOOKED_BY_ORG && (
        <>
          <ButtonCTA
            variant='contained'
            color='primary'
            onClick={toEnquiryView(() => send({ type: 'CONFIRM_BOOKING' }))}>
            Confirm booking
          </ButtonCTA>
          <CancelBookingButton
            onClick={toEnquiryView(() => send({ type: 'NOT_A_BOOKING' }))}
          />
        </>
      )}

      {state.matches('cancelled') && (
        <ButtonCTA
          color='primary'
          variant='contained'
          onClick={toEnquiryView(() => send({ type: 'REOPEN_ENQUIRY' }))}>
          Re-open event
        </ButtonCTA>
      )}

      {state.matches('expired') && (
        <>
          <ButtonCTA
            color='primary'
            variant='contained'
            onClick={editQuoteHandler}>
            Edit Quote
          </ButtonCTA>
          <HostMarkAsBookedButton onClick={markAsBookedClickHandler} />
          <CancelBookingButton
            onClick={toEnquiryView(() => send({ type: 'NOT_A_BOOKING' }))}
          />
        </>
      )}

      {activeMobileView !== inboxMobileView.ENQUIRY && (
        <ButtonCTA onClick={toEnquiryView()}>View details</ButtonCTA>
      )}

      {activeMobileView !== inboxMobileView.CHAT && (
        <ButtonCTA onClick={bottomClickHandler}>
          Message {thread?._organiser?.name || 'organiser'}
        </ButtonCTA>
      )}
    </Stack>
  );
};

export const OrganiserMenu = ({ thread, state, send }) => {
  const { activeMobileView, setActiveMobileView } = useContext(ViewContext);

  const { can } = thread;

  if (!can) return null;

  const toEnquiryView =
    (fn = () => {}) =>
    () => {
      setActiveMobileView(inboxMobileView.ENQUIRY);
      fn();
    };

  const bottomClickHandler = () => {
    setActiveMobileView(inboxMobileView.CHAT);
  };

  const markAsBookedClickHandler = toEnquiryView(() =>
    send({ type: 'MARK_AS_BOOKED' }),
  );

  const declineClickHandler = toEnquiryView(() => send({ type: 'CANCEL' }));

  return (
    <Stack
      p={2}
      className='enquiry-menu'
      direction='row'
      alignItems='center'
      justifyContent='start'
      spacing={2}>
      {state.matches('open') && (
        <>
          <ButtonCTA
            color='primary'
            variant='contained'
            onClick={toEnquiryView(() => send({ type: 'REQUEST_QUOTE' }))}>
            Request Quote
          </ButtonCTA>
          <OrganiserMarkAsBookedButton onClick={markAsBookedClickHandler} />
          <DeclineEventButton onClick={declineClickHandler} />
        </>
      )}

      {state.matches('quoteRequested') && (
        <>
          <OrganiserMarkAsBookedButton onClick={markAsBookedClickHandler} />
          <DeclineEventButton onClick={declineClickHandler} />
        </>
      )}
      {state.matches('quoteReceived') && (
        <>
          <ButtonCTA
            color='primary'
            variant='contained'
            onClick={toEnquiryView(() => send({ type: 'BOOK' }))}>
            Book now
          </ButtonCTA>
          <OrganiserMarkAsBookedButton onClick={markAsBookedClickHandler} />
          <DeclineEventButton onClick={declineClickHandler} />
        </>
      )}

      {state.matches('booked') && thread.status === status.BOOKED_BY_ORG && (
        <UnmarkAsBookedButton
          onClick={toEnquiryView(() => send({ type: 'UNMARK_AS_BOOKED' }))}
        />
      )}

      {state.matches('cancelled') && (
        <ButtonCTA
          color='primary'
          variant='contained'
          onClick={toEnquiryView(() => send({ type: 'REOPEN_ENQUIRY' }))}>
          Re-open Enquiry
        </ButtonCTA>
      )}
      {activeMobileView !== inboxMobileView.ENQUIRY && (
        <ButtonCTA onClick={toEnquiryView()}>View details</ButtonCTA>
      )}
      {activeMobileView !== inboxMobileView.CHAT && (
        <ButtonCTA onClick={bottomClickHandler}>Message venue</ButtonCTA>
      )}
    </Stack>
  );
};

function CancelBookingButton({ onClick, children = 'Cancel booking' }) {
  return <ButtonCTA onClick={onClick}>{children}</ButtonCTA>;
}

function DeclineEventButton({ onClick }) {
  return <CloseEnquiry onClick={onClick} text='Close event' size='large' />;
}

function HostMarkAsBookedButton({ onClick }) {
  return <ButtonCTA onClick={onClick}>Mark as booked</ButtonCTA>;
}

function OrganiserMarkAsBookedButton({ onClick }) {
  return <ButtonCTA onClick={onClick}>I&apos;ve booked this venue</ButtonCTA>;
}

function UnmarkAsBookedButton({ onClick }) {
  return <ButtonCTA onClick={onClick}>Unmark as booked</ButtonCTA>;
}

export const ButtonCTA = ({
  onClick,
  children,
  variant = 'outlined',
  color = 'white',
}) => {
  return (
    <Button
      sx={{ minWidth: 200, fontSize: '16px' }}
      size='large'
      color={color}
      variant={variant}
      onClick={onClick}>
      {children}
    </Button>
  );
};

export default EnquiryMenuContainer;
